import {Component, Injector, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {map} from 'rxjs/operators';
import {  BaseComponent } from "../../base.component";
import {Subscription} from 'rxjs';


@Component({
    selector : 'Section-title',
    host: { '[class]': 'myCustomClass' },
    template: `
    <h1 *ngIf="titleText" [innerHTML]="titleText"></h1>
    <h3 *ngIf="subtitleText" [innerHTML]="subtitleText"></h3>
    `,
    styleUrls: ["./section-title.components.scss"],
    encapsulation: ViewEncapsulation.None
})

export class SectiontitleComponent extends BaseComponent implements OnInit, OnDestroy {
  titleText: string;
  subtitleText: string;
  storeSub: Subscription;
  layoutSub: Subscription;

  constructor(injector : Injector) {
    super(injector);
  }

  ngOnInit() {
    if (this.control.attributes.bindLegend &&
      Object.keys(this.control.attributes.bindLegend).length)  {
      this.initStoreSub();
    } else {
      this.titleText = this.control.attributes.title;
      this.subtitleText = this.control.attributes.subtitle;
    }
  }

  initStoreSub(): void {
    this.layoutSub = this.layoutService.staticLayout.pipe(
      map(data => data.data.answers.page)
    ).subscribe(pageAnswers => {
      this.handleDataChange(pageAnswers);
    });
    this.storeSub = this.storeService.policyData$
    .subscribe(() => {
      this.handleDataChange(this.layoutService.staticLayout.getValue().data.answers.page);
    })
  }

  handleDataChange(policyData): void {
    this.titleText = this.control.attributes.title;
    this.subtitleText = this.control.attributes.subtitle;
    for (let [key, val] of Object.entries(this.control.attributes.bindLegend)) {
      if (this.titleText && this.titleText.includes(key)) {
        this.titleText = this.titleText.replace(key, policyData[val]);
      }
      if (this.subtitleText && this.subtitleText.includes(key)) {
        this.subtitleText = this.control.attributes.subtitle.replace(key, policyData[val]);
      }
    }
  }

  ngOnDestroy(): void {
    this.storeSub ? this.storeSub.unsubscribe() : false;
    this.layoutSub ? this.layoutSub.unsubscribe() : false;
  }
}



